export const setSessionStorage = (key: any, value: any) => {
    sessionStorage.setItem(key, value);
}
export const getSessionStorage = (key: any) => {
    return sessionStorage.getItem(key);
}
export const removeSessionStorage = (key: any) => {
    sessionStorage.removeItem(key);
}
export const clearSessionStorage = () => {
    sessionStorage.clear();
}
